module.exports = __webpack_public_path__ + "img/Jessica-ava.13e4807.png";